import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, message } from 'antd';
import { exportDashboardReport } from '../../../services/dashboard';

const ActionRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  padding-top: 4px;
`;

const ActionButtons = ({ filters }) => {
    const [loading, setLoading] = useState(false);

    const handleGenerateReport = async () => {
        setLoading(true);
        try {
            const blob = await exportDashboardReport(filters);
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Reporte_Dashboard_${new Date().toISOString().split('T')[0]}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            message.success('Reporte generado exitosamente');
        } catch (error) {
            console.error('Error generating report:', error);
            message.error('Error al generar el reporte');
        } finally {
            setLoading(false);
        }
    };

    return (
        <ActionRow>
            <Button
                size="large"
                loading={loading}
                onClick={handleGenerateReport}
                style={{
                    background: '#2a2a2a',
                    border: '1px solid #3a3a3a',
                    color: '#e0e0e0',
                    borderRadius: 8,
                    fontWeight: 600,
                }}
            >
                Generar Reporte
            </Button>
        </ActionRow>
    );
};

export default ActionButtons;
